import type { WineFormErrors } from './types';
import { FormSection } from '../ui/FormSection';

export interface WineDrinkingWindowFieldsProps {
  holdUntil: string;
  onHoldUntilChange: (value: string) => void;
  drinkBefore: string;
  onDrinkBeforeChange: (value: string) => void;
  errors: WineFormErrors;
  touched: Record<string, boolean>;
  onBlur: (field: string) => void;
  isSubmitting: boolean;
}

export const WineDrinkingWindowFields = ({
  holdUntil,
  onHoldUntilChange,
  drinkBefore,
  onDrinkBeforeChange,
  errors,
  touched,
  onBlur,
  isSubmitting,
}: WineDrinkingWindowFieldsProps) => (
  <FormSection title="Drinking Window">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Hold Until */}
      <div>
        <label htmlFor="holdUntil" className="block text-sm font-medium text-gray-700 mb-1">
          Hold Until (Year)
        </label>
        <input
          id="holdUntil"
          type="text"
          inputMode="numeric"
          value={holdUntil}
          onChange={(e) => onHoldUntilChange(e.target.value)}
          onBlur={() => onBlur('holdUntil')}
          disabled={isSubmitting}
          placeholder="e.g., 2025"
          className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
            touched.holdUntil && errors.holdUntil ? 'border-red-500' : 'border-gray-300'
          } ${isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''}`}
        />
        {touched.holdUntil && errors.holdUntil && (
          <p className="mt-1 text-sm text-red-600">{errors.holdUntil}</p>
        )}
      </div>

      {/* Drink Before */}
      <div>
        <label htmlFor="drinkBefore" className="block text-sm font-medium text-gray-700 mb-1">
          Drink Before (Year)
        </label>
        <input
          id="drinkBefore"
          type="text"
          inputMode="numeric"
          value={drinkBefore}
          onChange={(e) => onDrinkBeforeChange(e.target.value)}
          onBlur={() => onBlur('drinkBefore')}
          disabled={isSubmitting}
          placeholder="e.g., 2035"
          className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
            touched.drinkBefore && errors.drinkBefore ? 'border-red-500' : 'border-gray-300'
          } ${isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''}`}
        />
        {touched.drinkBefore && errors.drinkBefore && (
          <p className="mt-1 text-sm text-red-600">{errors.drinkBefore}</p>
        )}
      </div>
    </div>
  </FormSection>
);
